module.exports = __webpack_public_path__ + "static/media/ConferenceYear2015.087774f7.png";